import type { ReactNode } from "react";

interface PageLayoutProps {
	title: string;
	subtitle?: string;
	onClose?: () => void;
	children: ReactNode;
}

export function PageLayout({ title, subtitle, onClose, children }: PageLayoutProps) {
	return (
		<div className="page-container">
			<header className="page-layout__header">
				<div className="page-layout__header-row">
					<div>
						<h1 className="page-layout__title">{title}</h1>
						{subtitle && <p className="page-layout__subtitle">{subtitle}</p>}
					</div>
					{onClose && (
						<button
							type="button"
							className="page-layout__close"
							onClick={onClose}
							aria-label="Close"
						>
							✕
						</button>
					)}
				</div>
			</header>
			<div className="page-layout__content">{children}</div>
		</div>
	);
}
